export enum PrintPDFTypeEnum {
  INVOICE = 'invoice',
  INVOICE_ESP = 'invoice-esp',
  ESP = 'esp',
  SHIPPING_LABEL = 'shipping-label',
}
